import { useContext, useState } from 'react';
import { UseMutateFunction, useQueryClient } from 'react-query';
import { NotificationsContext } from '../../../common/notifications/Notifications';
import { useUpdateBusinessUnits } from './useUpdateBusinessUnits';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { AxiosResponse } from 'axios';
import { RoleBindingDto } from '../../../api-client';
import { UpdateBusinessUnitData } from '../GroupDetails.types';

type UseAddBusinessUnitModalFacade = (groupId: string) => {
  isAddBusinessUnitModalOpen: boolean;
  openAddBusinessUnitModal: (role: RoleBindingDto) => () => void;
  closeAddBusinessUnitModal: () => void;
  addBusinessUnit: UseMutateFunction<AxiosResponse<void>, ErrorResponse, UpdateBusinessUnitData>;
  isAddingBusinessUnit: boolean;
  selectedRole: RoleBindingDto | null;
};

export const useAddBusinessUnitModalFacade: UseAddBusinessUnitModalFacade = (groupId) => {
  const [isAddBusinessUnitModalOpen, setIsAddBusinessUnitModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState<RoleBindingDto | null>(null);

  const queryClient = useQueryClient();

  const { showNotification } = useContext(NotificationsContext);

  const openAddBusinessUnitModal = (role: RoleBindingDto) => () => {
    setSelectedRole(role);
    setIsAddBusinessUnitModalOpen(true);
  };

  const closeAddBusinessUnitModal = () => setIsAddBusinessUnitModalOpen(false);

  const onSuccess = () => {
    queryClient.invalidateQueries([`group-${groupId}-roles`]).then();
    showNotification('Business unit successfully added');
    closeAddBusinessUnitModal();
  };

  const onError = () => showNotification('An error occurred while adding business unit');

  const { updateBusinessUnit: addBusinessUnit, isUpdating: isAddingBusinessUnit } =
    useUpdateBusinessUnits(true, groupId, undefined, {
      onError,
      onSuccess,
    });

  return {
    isAddBusinessUnitModalOpen: isAddBusinessUnitModalOpen && !!selectedRole,
    openAddBusinessUnitModal,
    closeAddBusinessUnitModal,
    addBusinessUnit,
    isAddingBusinessUnit,
    selectedRole,
  };
};
